module.exports = __webpack_public_path__ + "static/media/39.c02e8d37.jpeg";